import { CloseIcon } from '@chakra-ui/icons';
import { Box, IconButton, Text } from '@chakra-ui/react';
import React from 'react';

interface Props {
  title?: string;
  text: string;
  withArrow?: boolean;
  onClose?: () => void;
  buttons?: React.ReactNode;
}

export const Toast = ({ title, text, withArrow, buttons, onClose }: Props) => (
  <Box
    position="relative"
    mt="5"
    borderRadius="16px"
    color="white"
    background="darkBg.100"
    border="1px solid #FFECDB33"
    boxShadow="0px 4px 16px 0px #00000052"
    maxWidth="440px"
    width="100%"
    p="4"
  >
    {withArrow && (
      <Box
        width={0}
        height={0}
        borderLeft="10px solid transparent"
        borderRight="10px solid transparent"
        borderBottom="10px solid #FFECDB33"
        position="absolute"
        top="-11px"
        left="calc(50% - 5px)"
        _after={{
          content: "''",
          width: 0,
          height: 0,
          borderLeft: '9px solid transparent',
          borderRight: '9px solid transparent',
          borderBottom: '9px solid #1B1F26',
          position: 'absolute',
          top: '2px',
          left: '-9px',
        }}
      ></Box>
    )}

    {!!title && (
      <Text fontWeight="600" fontSize="16px" lineHeight="24px">
        {title}
      </Text>
    )}

    <Text fontSize="14px" lineHeight="24px" opacity={0.8}>
      {text}
    </Text>

    {!!onClose && (
      <IconButton
        aria-label="close"
        position="absolute"
        top="-12px"
        left="-12px"
        width="24px"
        minWidth="24px"
        height="24px"
        padding="0"
        borderRadius="12px"
        background="green.100"
        _hover={{
          background: 'green.100',
          boxShadow: '0px 4px 16px 0px #00000052',
        }}
        onClick={onClose}
      >
        <CloseIcon color="text.brand" width="10px" />
      </IconButton>
    )}
    {buttons ? buttons : null}
  </Box>
);
